// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".student-tags {\n  text-align: center;\n  width: 100%;\n  max-width: 300px;\n}\n.student-tags > div:first-child {\n  width: calc(100% - 50px);\n  display: inline-block;\n}\n.student-tags > div:last-child {\n  width: 40px;\n  display: inline-block;\n}", ""]);
// Exports
module.exports = exports;
